<template>
  <div>
    <v-layout column v-if="shopLoad" align-center>
      <progress-q></progress-q>
    </v-layout>

    <!-- Lightbox foto -->
    <v-dialog v-model="photoZoom" max-width="500">
      <v-card style="background: #000; text-align: center; padding: 8px">
        <img :src="zoomedPhoto" style="max-width: 100%; max-height: 80vh; border-radius: 8px" />
        <div><v-btn flat dark @click="photoZoom = false"><v-icon>close</v-icon></v-btn></div>
      </v-card>
    </v-dialog>

    <!-- Popup aggiungi nota -->
    <v-dialog v-model="addNoteDialog" max-width="420" persistent>
      <v-card>
        <v-toolbar color="red lighten-2" dark dense>
          <v-toolbar-title>{{ getString("Aggiungi nota") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addNoteDialog = false"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 16px">
          <v-text-field v-model="newNoteAuthor" :label="getString('Autore (facoltativo)')" color="red lighten-2" />
          <v-textarea v-model="newNoteText" :label="getString('Nota')" color="red lighten-2" rows="4" auto-grow />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="addNoteDialog = false">{{ getString("Annulla") }}</v-btn>
          <v-btn class="q-orange-bk q-text-whitesmoke" :loading="isSavingNote" @click="addNote">
            <v-icon left small>save</v-icon>{{ getString("Salva") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Conferma eliminazione nota -->
    <v-dialog v-model="confirmDeleteNoteDialog" max-width="360">
      <v-card>
        <v-card-title class="headline">{{ getString("Elimina nota") }}</v-card-title>
        <v-card-text>{{ getString("Sei sicuro di voler eliminare questa nota?") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmDeleteNoteDialog = false">{{ getString("Annulla") }}</v-btn>
          <v-btn color="red darken-1" dark @click="deleteNote(pendingDeleteNoteId); confirmDeleteNoteDialog = false">{{ getString("Elimina") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Conferma eliminazione cliente CRM -->
    <v-dialog v-model="confirmDeleteDialog" max-width="380">
      <v-card>
        <v-card-title class="headline">{{ getString("Elimina cliente") }}</v-card-title>
        <v-card-text>{{ getString("Sei sicuro di voler eliminare questo cliente CRM? L'operazione non è reversibile.") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmDeleteDialog = false">{{ getString("Annulla") }}</v-btn>
          <v-btn color="red darken-1" dark :loading="savingCrm" @click="deleteCrmClient">{{ getString("Elimina") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Aggiungi cliente CRM manuale -->
    <v-dialog v-model="addCrmDialog" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="480" persistent>
      <v-card>
        <v-toolbar color="red lighten-2" dark dense>
          <v-toolbar-title>{{ getString("Aggiungi cliente manuale") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addCrmDialog = false"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 16px">
          <v-text-field v-model="crmForm.name" :label="getString('Nome') + ' *'" color="red lighten-2" />
          <v-text-field v-model="crmForm.surname" :label="getString('Cognome')" color="red lighten-2" />
          <v-text-field v-model="crmForm.email" :label="getString('Email')" color="red lighten-2" type="email" />
          <v-text-field v-model="crmForm.phone" :label="getString('Telefono')" color="red lighten-2" />
          <v-text-field v-model="crmForm.birthDate" :label="getString('Data di nascita')" color="red lighten-2" type="date" />
          <v-textarea v-model="crmForm.note" :label="getString('Nota')" color="red lighten-2" rows="3" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="addCrmDialog = false">{{ getString("Annulla") }}</v-btn>
          <v-btn class="q-orange-bk q-text-whitesmoke" :loading="savingCrm" @click="saveCrmClient">
            <v-icon left small>save</v-icon>{{ getString("Salva") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Scheda Cliente — usa v-dialog per avere footer sticky -->
    <v-dialog v-model="detailsDialog" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="800" persistent scrollable style="z-index: 9999">
      <v-card :style="$vuetify.breakpoint.smAndDown ? 'display:flex;flex-direction:column;height:100vh' : 'display:flex;flex-direction:column;max-height:85vh'">

        <!-- Header -->
        <v-toolbar color="red lighten-2" dark dense>
          <v-toolbar-title>{{ getString("Scheda cliente") }}</v-toolbar-title>
          <v-chip v-if="isCrmProfile" small color="blue-grey lighten-3" text-color="grey darken-3" style="margin-left: 8px">
            <v-icon small left>edit</v-icon>CRM
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn icon @click="detailsDialog = false"><v-icon>close</v-icon></v-btn>
        </v-toolbar>

        <!-- Body scrollabile -->
        <v-card-text style="flex: 1;  overflow-y: auto; padding: 20px">

          <v-layout v-if="isLoading" justify-center align-center style="min-height: 350px">
            <v-progress-circular indeterminate color="red lighten-2" size="64"></v-progress-circular>
          </v-layout>

          <div v-if="!isLoading && clientProfile">

            <!-- Riga superiore: info + stats + prenotazioni -->
            <v-layout row wrap>

              <!-- Colonna A: profilo + attivazione -->
              <v-flex xs12 sm6 style="padding-right: 20px">
                <!-- Avatar + nome -->
                <div class="profile-header">
                  <div v-if="!isCrmProfile" class="avatar-clickable" @click="openPhoto(avatarUrl(clientProfile.client))">
                    <v-avatar size="110">
                      <img :src="avatarUrl(clientProfile.client)" />
                    </v-avatar>
                  </div>
                  <div v-else>
                    <v-avatar size="110" color="blue-grey lighten-3">
                      <v-icon size="64" color="white">person</v-icon>
                    </v-avatar>
                  </div>
                  <div style="margin-top: 10px">
                    <v-chip v-if="isCrmProfile" small color="blue-grey lighten-4" text-color="grey darken-3">
                      <v-icon small left>edit</v-icon>{{ getString("CRM Manuale") }}
                    </v-chip>
                    <div v-if="!isCrmProfile" class="profile-status"
                      :style="{ color: clientProfile.client.isBanned ? '#e53935' : '#43a047' }">
                      <v-icon small :color="clientProfile.client.isBanned ? 'red darken-1' : 'green darken-1'">
                        {{ clientProfile.client.isBanned ? 'block' : 'check_circle' }}
                      </v-icon>
                      {{ clientProfile.client.isBanned ? getString("Bloccato") : getString("Normale") }}
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm6 style="padding-right: 12px">
                <!-- Info anagrafiche — sola lettura per utenti app -->
                <template v-if="!isCrmProfile">
                  <div class="profile-fullname">{{ clientProfile.client.surname }} {{ clientProfile.client.name }}
                  </div>
                  <div class="profile-info-row"><v-icon small class="mr-2" color="blue-grey">email</v-icon>{{
                    clientProfile.client.email || getString("Non disponibile") }}</div>
                  <div class="profile-info-row"><v-icon small class="mr-2" color="blue-grey">phone</v-icon>{{
                    clientProfile.client.phone || getString("Non disponibile") }}</div>
                  <div class="profile-info-row">
                    <v-icon small class="mr-2" color="blue-grey">cake</v-icon>{{
                      getFormattedOnlyDate(clientProfile.client.birthdate) || getString("Non disponibile") }}
                  </div>
                  <div class="profile-info-row">
                    <v-icon small class="mr-2" color="blue-grey">event</v-icon>
                    {{ getString("Cliente dal") }}: {{ getFormattedOnlyDate(clientProfile.client.dataRes ||
                      clientProfile.client.created) }}
                  </div>
                </template>
                <!-- Info modificabili per clienti CRM -->
                <template v-if="isCrmProfile">
                  <v-text-field v-model="crmEditForm.name" :label="getString('Nome')" color="red lighten-2" dense />
                  <v-text-field v-model="crmEditForm.surname" :label="getString('Cognome')" color="red lighten-2" dense />
                  <v-text-field v-model="crmEditForm.email" :label="getString('Email')" color="red lighten-2" dense type="email" />
                  <v-text-field v-model="crmEditForm.phone" :label="getString('Telefono')" color="red lighten-2" dense />
                  <v-text-field v-model="crmEditForm.birthDate" :label="getString('Data di nascita')" color="red lighten-2" dense type="date" />
                  <div class="profile-info-row" style="margin-top: 4px">
                    <v-icon small class="mr-2" color="blue-grey">event</v-icon>
                    {{ getString("Cliente dal") }}: {{ getFormattedOnlyDate(clientProfile.client.created) }}
                  </div>
                </template>
              </v-flex>
            </v-layout>

            <!-- Note (full width, in basso) -->
            <v-divider class="my-4"></v-divider>
            <div style="display:flex; align-items:center; margin-bottom:6px">
              <div class="section-title" style="margin:0; flex:1">
                <v-icon small class="mr-1" color="blue-grey">notes</v-icon>
                {{ getString("Note") }}
              </div>
              <v-btn icon small flat @click="addNoteDialog = true" style="margin:0" :title="getString('Aggiungi nota')"><v-icon color="red lighten-2">add_circle_outline</v-icon></v-btn>
            </div>

            <!-- Lista note -->
            <div style="max-height: 220px; overflow-y: auto; margin-bottom: 8px">
              <div v-if="clientNotes.length === 0" style="color: #aaa; font-size: 13px; padding: 8px 0">{{ getString("Nessuna nota") }}</div>
              <v-card v-for="n in clientNotes" :key="n.idNote" class="mb-1 elevation-0" style="border-left: 3px solid #d5725b; padding: 6px 10px">
                <div style="display:flex; justify-content:space-between; align-items:flex-start">
                  <div>
                    <div style="font-size:12px; color:#888; margin-bottom:2px">{{ getFormattedDate(n.createdDate) }}<span v-if="n.author" style="margin-left:6px; font-style:italic">— {{ n.author }}</span></div>
                    <div style="font-size:14px; white-space: pre-wrap">{{ n.note }}</div>
                  </div>
                  <v-btn icon small flat @click="pendingDeleteNoteId = n.idNote; confirmDeleteNoteDialog = true" style="margin:0"><v-icon small color="red lighten-2">delete</v-icon></v-btn>
                </div>
              </v-card>
            </div>
            <v-divider class="my-3"></v-divider>

            <div v-if="!isCrmProfile" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 16px; margin-top: 8px">
              <!-- Box Ban -->
              <div style="flex: 1 1 180px; min-width: 160px; display: flex; flex-direction: column">
                <div class="section-title" style="margin-top: 0">{{ getString("Blocco prenotazioni") }}</div>
                <div class="access-box"
                  :class="clientProfile.client.isBanned ? 'access-box--banned' : 'access-box--ok'">
                  <div class="access-box-header">
                    <v-icon small :color="clientProfile.client.isBanned ? '#c62828' : '#2e7d32'">{{
                      clientProfile.client.isBanned ? 'block' : 'check_circle' }}</v-icon>
                    <strong>{{ clientProfile.client.isBanned ? getString("Bloccato") : getString("Non bloccato")
                    }}</strong>
                  </div>
                  <div class="access-box-desc">
                    {{ clientProfile.client.isBanned
                      ? getString("Utente bloccato: non può effettuare prenotazioni")
                      : getString("Utente non bloccato") }}
                  </div>
                  <v-btn small @click="banUser(clientProfile.client)"
                    :class="clientProfile.client.isBanned ? 'green darken-1 white--text' : 'red darken-1 white--text'"
                    style="margin-top: 6px">
                    <v-icon small left>{{ clientProfile.client.isBanned ? 'lock_open' : 'block' }}</v-icon>
                    {{ clientProfile.client.isBanned ? getString("Sblocca") : getString("Banna") }}
                  </v-btn>
                </div>
              </div>

              <!-- Box Attivazione -->
              <div style="flex: 1 1 410px; display: flex; flex-direction: column" v-if="clientProfile.client">
                <div class="section-title" style="margin-top: 0">{{ getString("Attivazione account") }}</div>
                <div class="access-box" :class="isAccountExpired ? 'access-box--expired' : (clientProfile.client.canDoReservation ? 'access-box--ok' : 'access-box--off')">
                  <!-- Stato attuale -->
                  <div class="access-box-header">
                    <v-icon small :color="isAccountExpired ? '#c62828' : (clientProfile.client.canDoReservation ? '#2e7d32' : '#757575')">{{
                      isAccountExpired ? 'event_busy' : (clientProfile.client.canDoReservation ? 'event_available' : 'event_busy') }}</v-icon>
                    <strong>{{ isAccountExpired ? getString("Scaduto") : (clientProfile.client.canDoReservation ? getString("Attivo") : getString("Non attivo")) }}</strong>
                  </div>
                  <div class="access-box-desc" style="margin-bottom: 10px">
                    <span v-if="isAccountExpired">{{ getString("Scaduto il") }} <strong>{{ getFormattedOnlyDate(clientProfile.client.canDoReservationExpireDate) }}</strong></span>
                    <span v-else-if="clientProfile.client.canDoReservation">
                      <span v-if="clientProfile.client.canDoReservationExpireDate && clientProfile.client.canDoReservationExpireDate !== '0001-01-01T00:00:00'">
                        {{ getString("Scade il") }} <strong>{{ getFormattedOnlyDate(clientProfile.client.canDoReservationExpireDate) }}</strong>
                      </span>
                      <span v-else>{{ getString("Nessuna scadenza") }}</span>
                    </span>
                    <span v-else>{{ getString("Account non attivo") }}</span>
                  </div>

                  <v-divider style="margin-bottom: 10px"></v-divider>

                  <!-- Azione: attiva per sempre o fino a data -->
                  <div style="font-size: 12px; color: #888; margin-bottom: 6px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px">
                    {{ getString("Attiva fino al") }}:
                  </div>
                  <div style="display: flex; gap: 6px; align-items: center; flex-wrap: wrap">
                    <v-btn small depressed
                      :class="forever ? 'blue darken-1 white--text' : 'grey lighten-2'"
                      @click="forever = true">
                      <v-icon small left>all_inclusive</v-icon>{{ getString("Per sempre") }}
                    </v-btn>
                    <v-menu ref="dp3" :close-on-content-click="false" v-model="dp3" :nudge-right="40"
                      :return-value.sync="date" lazy transition="scale-transition" offset-y min-width="190px">
                      <v-btn slot="activator" small depressed
                        :class="!forever ? 'green darken-1 white--text' : 'grey lighten-2'"
                        @click="forever = false">
                        <v-icon small left>event</v-icon>{{ !forever && date ? getFormattedOnlyDate(date) : getString("Data specifica") }}
                      </v-btn>
                      <v-date-picker :locale="locale" :title-date-format="formatTitle" show-current color="red lighten-2"
                        v-model="date"
                        @input="forever = false; $refs.dp3.save(date)"></v-date-picker>
                    </v-menu>
                    <v-btn small class="q-orange-bk q-text-whitesmoke" @click="activeUser(clientProfile.client)">
                      <v-icon small left>check</v-icon>{{ getString("Conferma") }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <!-- Statistiche -->
            <div class="section-title">{{ getString("Statistiche") }}</div>
            <div class="stat-box">
              <div class="stat-item">
                <span class="stat-value">{{ clientProfile.stats.totalReservations }}</span>
                <span class="stat-label">{{ getString("Prenotazioni") }}</span>
              </div>
              <div class="stat-item" v-if="clientProfile.stats.daysSinceLastVisit !== null">
                <span class="stat-value">{{ clientProfile.stats.daysSinceLastVisit }}</span>
                <span class="stat-label">{{ getString("gg dall'ultima") }}</span>
              </div>
              <div class="stat-item"
                v-if="clientProfile.stats.avgDaysBetweenVisits !== null && clientProfile.stats.avgDaysBetweenVisits !== undefined">
                <span class="stat-value">{{ Math.round(clientProfile.stats.avgDaysBetweenVisits) }}</span>
                <span class="stat-label">{{ getString("gg medi tra visite") }}</span>
              </div>
              <div class="stat-item" v-if="clientProfile.stats.totalSpent > 0">
                <span class="stat-value">{{ clientProfile.stats.totalSpent.toFixed(0) }}€</span>
                <span class="stat-label">{{ getString("Spesa totale") }}</span>
              </div>
            </div>

            <div style="margin-top: 8px" v-if="clientProfile.stats.lastReservation">
              <div class="profile-info-row">
                <v-icon small class="mr-2" color="blue-grey">today</v-icon>
                {{ getString("Ultima visita") }}: <strong style="margin-left: 4px">{{
                  getFormattedOnlyDate(clientProfile.stats.lastReservation) }}</strong>
              </div>
            </div>

            <div style="margin-top: 6px"
              v-if="clientProfile.stats.favoriteServices && clientProfile.stats.favoriteServices.length > 0">
              <div style="font-size: 13px; color: #666; margin-bottom: 4px"><v-icon small class="mr-1">star</v-icon>{{
                getString("Servizi preferiti") }}</div>
              <v-chip small v-for="(s, i) in clientProfile.stats.favoriteServices" :key="i"
                class="q-orange-bk q-text-whitesmoke" style="margin: 2px 2px 0 0">{{ s }}</v-chip>
            </div>

            <v-divider class="my-3"></v-divider>




            <!-- Colonna B: ultime prenotazioni -->
            <v-flex xs12 sm12>
              <div class="section-title" style="margin-bottom: 10px">
                <v-icon small class="mr-1" color="blue-grey">history</v-icon>
                {{ getString("Ultime prenotazioni") }}
              </div>
              <div v-if="clientProfile.stats.lastReservations && clientProfile.stats.lastReservations.length > 0">
                <v-card v-for="(r, i) in clientProfile.stats.lastReservations" :key="i" class="res-card mb-2">
                  <div class="res-card-content">
                    <div class="res-date">{{ getFormattedDate(r.dateAndTime) }}</div>
                    <div class="res-service">{{ r.service || getString("N/D") }}</div>
                    <div class="res-employee" v-if="r.employeeName">
                      <v-icon small>person</v-icon> {{ r.employeeName }}
                    </div>
                    <div class="res-price" v-if="r.servicesPrice > 0">{{ r.servicesPrice.toFixed(2) }}€</div>
                  </div>
                </v-card>
              </div>
              <div v-else style="color: #aaa; font-size: 14px; padding: 12px 0">
                {{ getString("Nessuna prenotazione trovata") }}
              </div>
            </v-flex>



          </div>
        </v-card-text>

        <!-- Footer sticky -->
        <v-divider></v-divider>
        <v-card-actions style="padding: 12px 20px; background: #fafafa; flex: 0 0 auto; flex-shrink: 0">
          <v-btn v-if="isCrmProfile" flat color="red darken-1" @click="confirmDeleteCrm">
            <v-icon left small>delete</v-icon>{{ getString("Elimina") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="q-orange-bk q-text-whitesmoke" flat @click="detailsDialog = false">{{ getString("Chiudi") }}</v-btn>
          <v-btn v-if="isCrmProfile" class="q-orange-bk q-text-whitesmoke" :loading="savingCrm" @click="updateCrmClient">
            <v-icon left small>save</v-icon>{{ getString("Salva") }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <v-layout row wrap v-if="!shopLoad">
      <v-flex xs12>
        <v-card class="elevation-3 dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke elevation-1" style="height: 50px">
            <v-toolbar-title style="padding-bottom: 15px">
              <h3>{{ getString("Lista dei miei clienti") }}</h3>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout>
              <v-tooltip bottom>
                <v-btn slot="activator"  @click="getUserApp">
                  <v-icon>refresh</v-icon>
                </v-btn>
                <span>{{ getString('Aggiorna') }}</span>
              </v-tooltip>
             
              <div style="display: flex; margin-left: auto;">
                <v-tooltip bottom>
                  <span slot="activator">
                    <vue-json-to-csv :json-data="userapp" :labels="{
                      name: { title: 'Nome' },
                      surname: { title: 'Cognome' },
                      email: { title: 'Email' },
                      phone: { title: 'Telefono' },
                      created: { title: 'Cliente dal' },
                    }" :csv-title="getString('ListaClienti')" separator=";">
                      <v-btn>
                        <v-icon>download</v-icon>
                      </v-btn>
                    </vue-json-to-csv>
                  </span>
                  <span>{{ getString('Scarica lista clienti') }}</span>
                </v-tooltip>
              </div>
               
            </v-layout>
            <v-flex xs12 lg12 style="margin-top: 12px">
                <v-text-field type="text" v-model="search" :label="getString('Filtra')" solo color="red lighten-3" />
              </v-flex>
               <v-tooltip bottom>
                <v-btn slot="activator" class="q-orange-bk q-text-whitesmoke" @click="openAddCrmDialog" style="margin-left: 4px">
                  <v-icon>person_add</v-icon>
                </v-btn>
                <span>{{ getString('Nuovo cliente') }}</span>
              </v-tooltip>
            <v-data-table :pagination.sync="pagination" :headers="Headers" :items="userapp" item-key="idUser"
              :search="search" :rows-per-page-items="[10, 25, 50, 100, { text: getString('Tutto'), value: -1 }]"
              :rows-per-page-text="getString('Negozi per pagina')" :no-data-text="getString('Dati non disponibili')"
              :loading="loading" class="elevation-0">
              <template slot="items" slot-scope="props">
                <tr style="max-height: 100px; overflow: hidden; cursor: pointer">
                  <td class="text-xs-center" style="max-width:32px;">
                    <v-btn flat @click="openDetails(props.item)">
                      <v-icon>{{ props.item._isManual ? 'person_outline' : 'person' }}</v-icon>
                    </v-btn>
                  </td>
                  <td class="hidden-xs-only">
                    <v-list-tile-avatar>
                      <img :src="defaultAvatar(props.item)" />
                    </v-list-tile-avatar>
                  </td>
                  <td @click="props.expanded = !props.expanded" class="text-xs-left">
                    {{ props.item.name }}
                  </td>
                  <td @click="props.expanded = !props.expanded" class="text-xs-left">
                    {{ props.item.surname }}
                  </td>
                  <td class="text-xs-left hidden-xs-only">
                    {{ getFormattedOnlyDate(props.item.dataRes || props.item.created) }}
                  </td>
                  <td class="text-xs-left hidden-xs-only">
                    <span v-if="!props.item._isManual">{{ props.item.canDoReservation ? getString("Sì") : getString("No") }}</span>
                    <span v-else style="color: #aaa">—</span>
                  </td>
                  <td class="text-xs-left hidden-xs-only"
                    :style="{ color: props.item.isBanned ? 'red' : 'black', 'font-weight': props.item.isBanned ? 'bold' : 'normal' }">
                    <span v-if="!props.item._isManual">{{ props.item.isBanned ? getString("Bloccato") : getString("Normale") }}</span>
                    <span v-else style="color: #aaa">—</span>
                  </td>
                  <td>
                    <v-chip small :color="props.item._isManual ? 'blue-grey lighten-4' : 'green lighten-5'" text-color="grey darken-2">
                      <v-icon small left>{{ props.item._isManual ? 'edit' : 'phone_android' }}</v-icon>
                      {{ props.item._isManual ? getString("Manuale") : getString("App") }}
                    </v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import Moment from "moment";
import Modal from "../../utils/Modal";
import VueJsonToCsv from "vue-json-to-csv";

var ut = new Utils();
export default {
  name: "ShopUsers",
  props: ["shopID", "tab"],
  mounted: function () {
    this.getUserApp();
  },
  components: {
    ProgressQ,
    Moment,
    Modal,
    VueJsonToCsv,
  },
  computed: {
    Headers: function () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          { text: this.getString("Scheda"),  align: "center", sortable: false },
          { text: this.getString("Nome"),    align: "left",   sortable: true,  value: "name" },
          { text: this.getString("Cognome"), align: "left",   sortable: true,  value: "surname" },
          { text: this.getString("Tipo"),    align: "left",   sortable: true,  value: "_isManual" },
        ];
      }
      return [
        { text: this.getString("Scheda"),      align: "center", sortable: false },
        { text: this.getString("Foto"),        align: "left",   sortable: false },
        { text: this.getString("Nome"),        align: "left",   sortable: true,  value: "name" },
        { text: this.getString("Cognome"),     align: "left",   sortable: true,  value: "surname" },
        { text: this.getString("Cliente dal"), align: "left",   sortable: true,  value: "dataRes" },
        { text: this.getString("Attivo"),      align: "left",   sortable: true,  value: "canDoReservation" },
        { text: this.getString("Stato"),       align: "left",   sortable: true,  value: "isBanned" },
        { text: this.getString("Tipo"),        align: "left",   sortable: true,  value: "_isManual" },
      ];
    },
    profileFullName: function () {
      if (this.clientProfile && this.clientProfile.client) {
        return (this.clientProfile.client.surname || "") + " " + (this.clientProfile.client.name || "");
      }
      return "";
    },
    isAccountExpired: function () {
      if (!this.clientProfile || !this.clientProfile.client) return false;
      const c = this.clientProfile.client;
      if (!c.canDoReservation) return false;
      const exp = c.canDoReservationExpireDate;
      if (!exp || exp === '0001-01-01T00:00:00') return false;
      return new Date(exp) < new Date();
    },
  },
  data: () => {
    return {
      h: null,
      show: false,
      hidden: false,
      isLoading: false,
      shopLoad: false,
      userapp: [],
      loading: false,
      search: "",
      pagination: { page: 1 },
      detailsDialog: false,
      clientProfile: null,
      clientNotes: [],
      newNoteText: "",
      newNoteAuthor: "",
      addNoteDialog: false,
      confirmDeleteNoteDialog: false,
      pendingDeleteNoteId: null,
      forever: true,
      date: new Moment().add("1", "y").format("YYYY-MM-DD"),
      dp3: false,
      photoZoom: false,
      zoomedPhoto: "",
      isSavingNote: false,
      isCrmProfile: false,
      addCrmDialog: false,
      confirmDeleteDialog: false,
      savingCrm: false,
      crmForm: { name: '', surname: '', email: '', phone: '', birthDate: null, note: '' },
      crmEditForm: { idCrmClient: 0, name: '', surname: '', email: '', phone: '', birthDate: null, note: '' },
    };
  },
  watch: {
    shopID: function () {
      if (this.shopID > 0) {
        this.getUserApp();
      }
    },
  },
  methods: {
    getFormattedDate: function (date, format) {
      if (format == null) format = "DD/MM/YYYY HH:mm";
      return new Moment(date).format(format);
    },
    getFormattedOnlyDate: function (date, format) {
      if (format == null) format = "DD/MM/YYYY";
      const d = new Moment(date);
      if (d.isValid())
        return d.format(format);
      return null;
    },
    openPhoto: function (url) {
      this.zoomedPhoto = url;
      this.photoZoom = true;
    },
    openDetails: function (item) {
      let self = this;
      self.detailsDialog = true;
      self.clientProfile = null;
      self.clientNotes = [];
      self.newNoteText = "";
      self.newNoteAuthor = "";
      self.isLoading = true;
      self.isCrmProfile = !!item._isManual;
      if (item._isManual) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/crm/clients/" + item.idCrmClient + "/profile",
            { headers: self.$store.getters.tokenHeader, withCredentials: true }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            var profile = response.data.data;
            self.clientProfile = { client: profile.client, stats: profile.stats, notes: [] };
            self.crmEditForm = {
              idCrmClient: profile.client.idCrmClient,
              name: profile.client.name || '',
              surname: profile.client.surname || '',
              email: profile.client.email || '',
              phone: profile.client.phone || '',
              birthDate: profile.client.birthDate ? new Moment(profile.client.birthDate).format('YYYY-MM-DD') : null,
              note: profile.client.note || ''
            };
            // Carica note CRM separatamente (con migrazione lazy)
            ajax.axios
              .get(
                ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/crm/clients/" + item.idCrmClient + "/notes",
                { headers: self.$store.getters.tokenHeader, withCredentials: true }
              )
              .then(function (r) {
                ajax.validateToken(r.headers, self.$store);
                self.clientNotes = r.data.data || [];
              })
              .catch(function () {});
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
            self.detailsDialog = false;
          })
          .finally(function () { self.isLoading = false; });
      } else {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/clients/client/" + item.idUser + "/profile",
            { headers: self.$store.getters.tokenHeader, withCredentials: true }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.clientProfile = response.data.data;
            self.clientNotes = self.clientProfile.notes || [];
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage
            );
            self.detailsDialog = false;
          })
          .finally(function () { self.isLoading = false; });
      }
    },
    addNote: function () {
      let self = this;
      if (!self.newNoteText.trim()) return;
      self.isSavingNote = true;
      var url = self.isCrmProfile
        ? ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/crm/clients/" + self.crmEditForm.idCrmClient + "/notes"
        : ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/clients/client/" + self.clientProfile.client.idUser + "/notes";
      ajax.axios
        .post(url, { note: self.newNoteText.trim(), author: self.newNoteAuthor.trim() },
          { headers: self.$store.getters.tokenHeader, withCredentials: true })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.clientNotes = response.data.data || [];
          self.newNoteText = "";
          self.newNoteAuthor = "";
          self.addNoteDialog = false;
          self.$emit("siteAlertSuccess", self.getString("Nota aggiunta"));
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        })
        .finally(function () { self.isSavingNote = false; });
    },
    deleteNote: function (idNote) {
      let self = this;
      var url = self.isCrmProfile
        ? ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/crm/clients/" + self.crmEditForm.idCrmClient + "/notes/" + idNote
        : ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/clients/client/" + self.clientProfile.client.idUser + "/notes/" + idNote;
      ajax.axios
        .delete(url, { headers: self.$store.getters.tokenHeader, withCredentials: true })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.clientNotes = self.clientNotes.filter(function (n) { return n.idNote !== idNote; });
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        });
    },
    activeUser: function (item) {
      let self = this;
      if (this.shopID > 0) {
        this.isLoading = true;
        ajax.axios
          .put(
            ajax.baseUrl() + "/admin/shops/shop/" + this.shopID + "/users/" + item.idUser + "/active",
            { date: this.forever ? null : this.date },
            { headers: self.$store.getters.tokenHeader, withCredentials: true }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            item.canDoReservation = true;
            self.$emit("siteAlertSuccess", self.getString("Utente attivato correttamente"));
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage
            );
          })
          .finally(function () {
            self.getUserApp();
            self.isLoading = false;
            self.openDetails(item);
          });
      }
    },
    banUser: function (item) {
      let self = this;
      if (this.shopID > 0) {
        if (item.isBanned) {
          ajax.axios
            .delete(
              ajax.baseUrl() + "/admin/shops/shop/" + this.shopID + "/clients/client/" + item.idBan,
              { headers: self.$store.getters.tokenHeader, withCredentials: true }
            )
            .then(function (response) {
              ajax.validateToken(response.headers, self.$store);
              item.isBanned = false;
              self.$emit("siteAlertSuccess", self.getString("Utente sbloccato"));
              self.openDetails(item);
            })
            .catch(function (error) {
              var auth = ajax.checkAuth(error, self.$store, self.$router);
              self.$emit(
                "siteAlert",
                auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage
              );
            });
        } else {
          ajax.axios
            .put(
              ajax.baseUrl() + "/admin/shops/shop/" + this.shopID + "/clients/client/" + item.idUser,
              {},
              { headers: self.$store.getters.tokenHeader, withCredentials: true }
            )
            .then(function (response) {
              ajax.validateToken(response.headers, self.$store);
              item.isBanned = true;
              item.idBan = response.data.data;
              self.$emit("siteAlertSuccess", self.getString("Utente bloccato"));
              self.openDetails(item);
            })
            .catch(function (error) {
              var auth = ajax.checkAuth(error, self.$store, self.$router);
              self.$emit(
                "siteAlert",
                auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage
              );
            });
        }
      }
    },
    defaultAvatar: function (item) {
      if (
        !item.photo ||
        item.photo === "images/u_placeholder.jpg" ||
        item.photo === "/images/u_placeholder.jpg"
      ) {
        item.photo = "/../../../../static/img/default-avatar.png";
        return item.photo;
      } else return item.photo.startsWith('http') ? item.photo : ajax.baseUrl() + item.photo;
    },
    avatarUrl: function (item) {
      if (!item || !item.photo || item.photo === "images/u_placeholder.jpg" || item.photo === "/images/u_placeholder.jpg") {
        return "/../../../../static/img/default-avatar.png";
      }
      return item.photo.startsWith('http') ? item.photo : ajax.baseUrl() + item.photo;
    },
    getUserApp: function () {
      let self = this;
      if (this.shopID > 0) {
        this.loading = true;
        ajax.axios
          .get(ajax.baseUrl() + "/admin/shops/shop/" + this.shopID + "/clients", {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          })
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.loading = false;
            const data = response.data.data;
            const registered = (data.registered || []).map(function(u) { return Object.assign({}, u, { _isManual: false }); });
            const manual = (data.manual || []).map(function(u) { return Object.assign({}, u, { _isManual: true }); });
            self.userapp = registered.concat(manual);
            self.$forceUpdate();
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.loading = false;
            self.$emit(
              "siteAlert",
              auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage
            );
          });
      }
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    openAddCrmDialog: function () {
      this.crmForm = { name: '', surname: '', email: '', phone: '', birthDate: null, note: '' };
      this.addCrmDialog = true;
    },
    saveCrmClient: function () {
      let self = this;
      if (!self.crmForm.name) {
        self.$emit("siteAlert", self.getString("Il nome è obbligatorio"));
        return;
      }
      self.savingCrm = true;
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/crm/clients",
          self.crmForm,
          { headers: self.$store.getters.tokenHeader, withCredentials: true }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.addCrmDialog = false;
          self.$emit("siteAlertSuccess", self.getString("Cliente aggiunto"));
          self.getUserApp();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        })
        .finally(function () { self.savingCrm = false; });
    },
    updateCrmClient: function () {
      let self = this;
      self.savingCrm = true;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/crm/clients/" + self.crmEditForm.idCrmClient,
          self.crmEditForm,
          { headers: self.$store.getters.tokenHeader, withCredentials: true }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", self.getString("Cliente aggiornato"));
          if (self.clientProfile && self.clientProfile.client) {
            Object.assign(self.clientProfile.client, self.crmEditForm);
          }
          self.getUserApp();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        })
        .finally(function () { self.savingCrm = false; });
    },
    confirmDeleteCrm: function () {
      this.confirmDeleteDialog = true;
    },
    deleteCrmClient: function () {
      let self = this;
      self.savingCrm = true;
      ajax.axios
        .delete(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/crm/clients/" + self.crmEditForm.idCrmClient,
          { headers: self.$store.getters.tokenHeader, withCredentials: true }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.confirmDeleteDialog = false;
          self.detailsDialog = false;
          self.$emit("siteAlertSuccess", self.getString("Cliente eliminato"));
          self.$emit("crmClientDeleted", self.crmEditForm.idCrmClient);
          self.getUserApp();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        })
        .finally(function () { self.savingCrm = false; });
    },
  },
};
</script>

<style scoped>
.avatar-clickable {
  cursor: zoom-in;
  transition: transform 0.15s;
}

.avatar-clickable:hover {
  transform: scale(1.08);
}

.profile-info-row {
  padding: 4px 0;
  font-size: 14px;
  text-align: center;
  /* display: flex;
  align-items: center; */
}

.profile-stat-row {
  padding: 4px 0;
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.custom-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(128, 128, 128, 0.6);
  z-index: 9999;
}

@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: bisque;
  }

  100% {
    background-color: transparent;
  }
}

.profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0 12px;
}

.profile-fullname {
  font-size: 18px;
  font-weight: 600;
  margin-top: 8px;
  text-align: center;
}

.profile-status {
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin: 12px 0 6px;
}

.section-subtitle {
  font-size: 13px;
  color: #777;
}

.stat-box {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 70px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 8px 12px;
}

.stat-value {
  font-size: 22px;
  font-weight: bold;
  color: #d5725b;
}

.stat-label {
  font-size: 11px;
  color: #888;
  text-align: center;
  margin-top: 2px;
}

.res-card {
  border-left: 3px solid #d5725b !important;
  padding: 8px 12px !important;
}

.res-card-content {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.res-date {
  font-size: 13px;
  color: #555;
  min-width: 130px;
}

.res-service {
  flex: 1;
  font-size: 14px;
}

.res-employee {
  font-size: 12px;
  color: #888;
  width: 100%;
}

.res-price {
  font-size: 14px;
  font-weight: bold;
  color: #43a047;
}

.access-row {
  gap: 16px;
}

.access-col {
  display: flex;
  flex-direction: column;
}

.access-box {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 10px 12px;
  background: #fafafa;
  flex: 1;
}

.access-box--ok {
  border-color: #a5d6a7;
  background: #f1f8f1;
}

.access-box--banned {
  border-color: #ef9a9a;
  background: #fff5f5;
}

.access-box--off {
  border-color: #e0e0e0;
  background: #f5f5f5;
}

.access-box--expired {
  border-color: #ef9a9a;
  background: #fff5f5;
}

.access-box-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  font-size: 14px;
}

.access-box-desc {
  font-size: 13px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopUsers.vue